/* eslint-disable import/prefer-default-export */
import TechnicalMaterialRequests from '../../server/technicalMaterial';
import { addLoading, removeLoading } from './loading';

export const getListTechnicalMaterial = (limit, skip, search, orderBy, field) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await TechnicalMaterialRequests.getListTechnicalMaterial(limit, skip, search, orderBy, field);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvTechnicalMaterial = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await TechnicalMaterialRequests.getCsvTechnicalMaterial();
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadCsvTechnicalMaterial = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await TechnicalMaterialRequests.uploadCsvTechnicalMaterial(file);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateTechnicalMaterial = technicalMaterialParameter => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await TechnicalMaterialRequests.updateTechnicalMaterial(technicalMaterialParameter);
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadFileTechnicalMaterial = (file, fileName, technicalMaterialId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await TechnicalMaterialRequests.uploadFileTechnicalMaterial(file, fileName, technicalMaterialId);
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteTechnicalMaterial = technicalMaterialId => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await TechnicalMaterialRequests.deleteTechnicalMaterial(technicalMaterialId);
  } finally {
    dispatch(removeLoading());
  }
};
